import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/admin/person-icon.svg'


const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 1,
  class: "flex justify-center mt-10"
}
const _hoisted_3 = { class: "navigation flex pb-6 w-full justify-start gap-4" }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "inline-flex flex-row border border-gray-200 bg-gray-50 p-1 rounded-full gap-1 mb-8" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 3,
  class: "mt-14"
}
const _hoisted_9 = { class: "rounded-xl bg-white border border-gray-200" }
const _hoisted_10 = { class: "text-2xl text-gray-900 font-semibold p-6 border-b border-b-2 border-gray-200" }
const _hoisted_11 = { class: "min-w-full w-full upload-preview-table" }
const _hoisted_12 = { class: "columns border-b border-blue-50" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", { class: "text-start text-xs text-gray-600 font-medium py-3" }, null, -1)
const _hoisted_14 = { class: "text-start text-xs text-gray-600 font-medium py-3" }
const _hoisted_15 = { class: "text-start text-xs text-gray-600 font-medium py-3" }
const _hoisted_16 = { class: "text-start text-xs text-gray-600 font-medium py-3" }
const _hoisted_17 = { class: "text-start text-xs text-gray-600 font-medium py-3" }
const _hoisted_18 = { class: "text-start text-xs text-gray-600 font-medium py-3" }
const _hoisted_19 = { class: "text-start text-xs text-gray-600 font-medium py-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { cxlass: "pl-2 py-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Person Icon"
  })
], -1)
const _hoisted_21 = { class: "text-sm text-gray-600 py-6" }
const _hoisted_22 = { class: "text-sm text-gray-600 py-6" }
const _hoisted_23 = { class: "text-sm text-gray-600 py-6" }
const _hoisted_24 = { class: "text-sm text-gray-600 py-6" }
const _hoisted_25 = { class: "text-sm text-gray-600 py-6" }
const _hoisted_26 = { class: "text-sm text-gray-600 py-6" }
const _hoisted_27 = { class: "flex items-center justify-between w-full pt-8" }
const _hoisted_28 = { class: "h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5" }
const _hoisted_29 = { class: "flex items-center" }
const _hoisted_30 = { class: "p-8 relative" }
const _hoisted_31 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_32 = { class: "mt-6 text-center" }
const _hoisted_33 = { class: "mt-6 font-semibold text-2xl text-gray-900" }
const _hoisted_34 = { class: "font-normal text-sm text-gray-600 text-center mt-2" }
const _hoisted_35 = { class: "flex justify-around items-center" }
const _hoisted_36 = { key: 4 }

import { onMounted, ref, onBeforeMount, reactive, watch } from "vue";
import { useRouter } from "vue-router";
import { useSchoolStore } from "@/stores/schoolStore";
import { useLearnerStore } from "@/stores/learnerStore";
import TeacherOnboardingComponent from "../components/TeacherOnboardingComponent.vue";
import TeacherDetails from "@/modules/main/components/TeacherDetailsComponent.vue";
import { useRolloverStore } from "@/stores/rolloverStore";
import { Rollover } from "@/interfaces/rollover.interface";
import ArchiveUnarchiveComponent from "@/modules/main/components/internal-tools/InternalArchiveContentComponent.vue";
import AdminOverviewComponent from "@/modules/main/components/AdminOverviewComponent.vue";
import GradesClassesDetailsComponent from "../components/GradesClassesDetailsComponent.vue";
import RolloverAlertComponent from "../components/RolloverAlertComponent.vue";
import PageHeaderComponent from "@/components/global/PageHeaderComponent.vue";
import CompleteRolloverModals from "@/modules/main/components/modals/CompleteRolloverModals.vue";
import AdminModals from "@/modules/main/views/modals/AdminModals.vue";

//variables

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminView',
  setup(__props) {

const hideSection = ref(true);
const uploadedLearners = ref<any>([]);
const showLearnersBulkUploadProgressModal = ref(false);
const showModal = ref(false);
const showRollover = ref(false);
const completeRolloverModal = ref(false);
const confirmRolloverDateModal = ref(false);
const rolloverDate = ref("2024-01-01");
const isActive = ref<string>("");
const showSendDetails = ref(false);
const step = ref(0);
const loading = ref(false);
const isActiveSchoolDetails = ref(true);
const errorMessage = ref(false);
const uploadPreviewCard = ref(false);
const goToAssignModal = ref(false);
const completeClassReviewModal = ref(false);
const currentOpenGrade = ref(null);
const checkboxChecked: { [key: string]: boolean } = reactive({});
const selectedGrade = ref(null);

const router = useRouter();
const rolloverStore = useRolloverStore();

// stores
const schoolStore = useSchoolStore();
const learnerStore = useLearnerStore();

const confirmRolloverComplete = async () => {
  const currentRollOver = rolloverStore.rollover as Rollover;

  if (currentRollOver) {
    currentRollOver.isComplete = true;
    await rolloverStore.updateRolloverObject(currentRollOver);
  }

  router.push("/main/internal");
};

// Fetch the initial country from the store and set `selectedOption` if it matches an option
onBeforeMount(async () => {
  await updateSchoolDetails();
});

const updateState = ()=>{
  showSendDetails.value = false;
  //clear the state
  schoolStore.enableSentModal = false;
};
const updateSchoolDetails = async () => {

  const currentSchool = schoolStore.getCurrentSchool;

  if (currentSchool) {
    await rolloverStore.fetchSchoolRollover(currentSchool._id);

    if (rolloverStore.rollover?.rolloverDate) {
      const date = new Date(rolloverStore.rollover?.rolloverDate);

      // date in format YYYY-MM-DD
      rolloverDate.value = date.toISOString().split('T')[0];
    }

    if (
      rolloverStore.rollover &&
      rolloverStore.rollover?.school === schoolStore.currentSchool?._id &&
      rolloverStore.rollover?.isComplete !== true
      ) {
        showRollover.value = true;
    } else {
        showRollover.value = false;
    }
  }
};

onMounted(() => {
  isActive.value = "overview";
});

const setActive = (section: string) => {
  isActive.value = section;
};

// Watch for changes in gradeLevels
watch(
  () => schoolStore.currentSchoolStructure?.gradeLevels,
  (newVal, oldVal) => {
    if (newVal !== oldVal) {
      // Trigger the modal when gradeLevels change
      showSendDetails.value = schoolStore?.enableSentModal;

      //clear the state
      //reset step back to zero
      schoolStore.step = 0;
      //clear the selected grades
      schoolStore.SelectedGrades = [];

      //clear teachers array in the state
      if (schoolStore.initialSchoolStructure) {
        schoolStore.initialSchoolStructure.teachers = [];
      }

      //clear classGroups array in the state
      if (schoolStore.initialSchoolStructure) {
        schoolStore.initialSchoolStructure.classGroups = [];
      }
    }
  }
);

const submitLearnersForUpload = async () => {
  loading.value = true;
  try {
    let request = await learnerStore.bulkCreateLearners(uploadedLearners.value);
    showLearnersBulkUploadProgressModal.value = true;
    loading.value = false;
  } catch (error) {
    console.error(error);
    errorMessage.value = false;
  }
};

const closeSuccessFailModal = () => {
  errorMessage.value = false;
};

const uploadInProgress = () => {
  showLearnersBulkUploadProgressModal.value = false;
  hideSection.value = false;
  uploadedLearners.value = [];
};

const clearLearners = () => {
  uploadedLearners.value = [];
  hideSection.value = false;
};

// Confirm the selection in the modal
const confirmSelection = (grade: any) => {
  checkboxChecked[grade] = true; // Keep the checkbox checked
  currentOpenGrade.value = grade; // Open the grade section
  showModal.value = false; // Close the modal
};

// Cancel the selection and uncheck the checkbox
const cancelSelection = (grade: any) => {
  currentOpenGrade.value = null; // Close the grade section
  checkboxChecked[grade] = false; // Uncheck the checkbox if modal is cancelled
  showModal.value = false; // Close the modal
};

const confirmClassReview = async () => {
  const currentRollOver = rolloverStore.rollover as Rollover;

  if (currentRollOver) {
    currentRollOver.status.classReview = "pending_job_run";
    await rolloverStore.updateRolloverObject(currentRollOver);
  }

  // completeClassReviewModal.value = false;
  router.push("/main/internal");
};
// student bulk upload END

return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageHeaderComponent, {
      pageHeading: _ctx.$t('admin_screens.main_title')
    }, null, 8, ["pageHeading"]),
    (
      _unref(schoolStore).currentSchoolStructure &&
      _unref(schoolStore).currentSchoolStructure?.gradeLevels.length < 1
    )
      ? (_openBlock(), _createBlock(TeacherOnboardingComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (showRollover.value && _unref(rolloverStore).loader.rollover != true)
            ? (_openBlock(), _createBlock(RolloverAlertComponent, {
                key: 0,
                class: "mt-6",
                rollover: (_unref(rolloverStore).rollover as Rollover),
                onCompleteRolloverModal: _cache[0] || (_cache[0] = ($event: any) => (completeRolloverModal.value = $event)),
                onConfirmRolloverDateModal: _cache[1] || (_cache[1] = ($event: any) => (confirmRolloverDateModal.value = $event))
              }, null, 8, ["rollover"]))
            : _createCommentVNode("", true),
          (step.value == 0)
            ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["py-2 px-8 flex items-center gap-1 font-medium", {
            'text-blue-600 border-b-2 border-blue-600': isActive.value === 'overview',
            'text-gray-500 border-b-2 border-transparent': isActive.value !== 'overview',
          }]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (setActive('overview')))
                  }, _toDisplayString(_ctx.$t("admin_screens.bulk_upload_students.overview")), 3),
                  _createElementVNode("button", {
                    class: _normalizeClass(["py-2 px-8 flex items-center gap-1 font-medium", {
            'text-blue-600 border-b-2 border-blue-600': isActive.value === 'school',
            'text-gray-500 border-b-2 border-transparent': isActive.value !== 'school',
          }]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (setActive('school')))
                  }, _toDisplayString(_ctx.$t("admin_screens.bulk_upload_students.school_details")), 3),
                  _createElementVNode("button", {
                    class: _normalizeClass(["py-2 px-8 flex items-center gap-1 font-medium", {
            'text-blue-600 border-b-2 border-blue-600': isActive.value === 'archive & unarchive',
            'text-gray-500 border-b-2 border-transparent': isActive.value !== 'archive & unarchive',
          }]),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (setActive('archive & unarchive')))
                  }, " Archive & Unarchive ", 2)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            (isActive.value === 'overview')
              ? (_openBlock(), _createBlock(AdminOverviewComponent, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          (isActive.value === 'school' && uploadPreviewCard.value === false)
            ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["py-2 px-3 rounded-full text-sm font-semibold", { 'shadow-md': isActiveSchoolDetails.value }]),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (isActiveSchoolDetails.value = true))
                  }, _toDisplayString(_ctx.$t("admin_screens.grade_and_classes")), 3),
                  _createElementVNode("button", {
                    class: _normalizeClass(["py-2 px-3 rounded-full text-sm font-semibold", { 'shadow-md': !isActiveSchoolDetails.value }]),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (isActiveSchoolDetails.value = false))
                  }, _toDisplayString(_ctx.$t("admin_screens.teacher_details")), 3)
                ]),
                (isActiveSchoolDetails.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(GradesClassesDetailsComponent)
                    ]))
                  : _createCommentVNode("", true),
                (!isActiveSchoolDetails.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(TeacherDetails)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (isActive.value === 'school' && uploadPreviewCard.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t("archive_flow.upload_preview_header")), 1),
                  _createElementVNode("table", _hoisted_11, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("archive_flow.learners_table.email")), 1),
                        _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("archive_flow.learners_table.first_name")), 1),
                        _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("archive_flow.learners_table.last_name")), 1),
                        _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t("admin_screens.bulk_upload_students.student_number")), 1),
                        _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t("admin_screens.bulk_upload_students.password")), 1),
                        _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t("admin_screens.bulk_upload_students.class_group")), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadedLearners.value, (learner, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          class: "mb-1"
                        }, [
                          _hoisted_20,
                          _createElementVNode("td", _hoisted_21, _toDisplayString(learner.email), 1),
                          _createElementVNode("td", _hoisted_22, _toDisplayString(learner.firstName), 1),
                          _createElementVNode("td", _hoisted_23, _toDisplayString(learner.lastName), 1),
                          _createElementVNode("td", _hoisted_24, _toDisplayString(learner.studentNumber), 1),
                          _createElementVNode("td", _hoisted_25, _toDisplayString(learner.password), 1),
                          _createElementVNode("td", _hoisted_26, _toDisplayString(learner.classGroup), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (uploadPreviewCard.value = false && isActive.value === 'school')),
                    class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg ms-10 py-2 px-4 flex items-center shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white"
                  }, [
                    _createElementVNode("span", _hoisted_28, [
                      _createVNode(_component_rl_icon, {
                        icon: 'rl-small-back-arrow',
                        title: 'rl small back arrow',
                        "aria-hidden": "true"
                      })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("admin_screens.bulk_upload_students.back")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("button", {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (uploadPreviewCard.value = false && clearLearners)),
                      class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-4 font-medium flex items-center bg-transparent me-4 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white"
                    }, _toDisplayString(_ctx.$t("admin_screens.bulk_upload_students.cancel")), 1),
                    _createElementVNode("button", {
                      onClick: submitLearnersForUpload,
                      class: "rounded-lg py-2 px-4 text-white flex items-center font-semibold bg-blue-600 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]"
                    }, [
                      (loading.value)
                        ? (_openBlock(), _createBlock(_component_spinner_loader, {
                            key: 0,
                            color: 'text-white dark:text-white mr-2'
                          }))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("admin_screens.bulk_upload_students.submit")), 1)
                    ])
                  ])
                ]),
                _createVNode(_component_modal, {
                  showCloseButton: true,
                  widthClass: 'max-w-lg',
                  open: errorMessage.value,
                  onLocalModalOpen: _cache[9] || (_cache[9] = ($event: any) => (errorMessage.value === true))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", {
                          class: "absolute top-6 right-4 cursor-pointer",
                          onClick: closeSuccessFailModal
                        }, [
                          _createVNode(_component_rl_icon, {
                            icon: 'rl-large-close',
                            title: 'rl large close',
                            "aria-hidden": "true"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_rl_icon, {
                            icon: 'rl-exclamation-bg-logo',
                            title: 'rl exclamation bg logo',
                            "aria-hidden": "true"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("h3", _hoisted_33, _toDisplayString(_ctx.$t("archive_flow.modals.incomplete")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t("archive_flow.modals.error_message")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("button", {
                          onClick: closeSuccessFailModal,
                          type: "button",
                          class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-8 mt-8 w-full"
                        }, _toDisplayString(_ctx.$t("archive_flow.modals.close")), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["open"])
              ]))
            : _createCommentVNode("", true),
          (isActive.value === 'archive & unarchive')
            ? (_openBlock(), _createElementBlock("section", _hoisted_36, [
                _createVNode(ArchiveUnarchiveComponent)
              ]))
            : _createCommentVNode("", true)
        ])),
    _createVNode(AdminModals, {
      completeClassReviewModal: completeClassReviewModal.value,
      goToAssignModal: goToAssignModal.value,
      showLearnersBulkUploadProgressModal: showLearnersBulkUploadProgressModal.value,
      showModal: showModal.value,
      showSendDetails: showSendDetails.value,
      selectedGrade: selectedGrade.value ?? null,
      onConfirmClassReview: confirmClassReview,
      onUploadInProgress: uploadInProgress,
      onCancelSelection: cancelSelection,
      onConfirmSelection: confirmSelection,
      onConfirmRolloverComplete: confirmRolloverComplete,
      "onUpdate:completeClassReviewModal": _cache[10] || (_cache[10] = ($event: any) => (completeClassReviewModal.value = $event)),
      "onUpdate:goToAssignModal": _cache[11] || (_cache[11] = ($event: any) => (goToAssignModal.value = $event)),
      "onUpdate:showLearnersBulkUploadProgressModal": _cache[12] || (_cache[12] = ($event: any) => (showLearnersBulkUploadProgressModal.value = $event)),
      "onUpdate:showModal": _cache[13] || (_cache[13] = ($event: any) => (showModal.value = $event)),
      "onUpdate:showSendDetails": updateState
    }, null, 8, ["completeClassReviewModal", "goToAssignModal", "showLearnersBulkUploadProgressModal", "showModal", "showSendDetails", "selectedGrade"]),
    _createVNode(CompleteRolloverModals, {
      confirmRolloverDateModal: confirmRolloverDateModal.value,
      completeRolloverModal: completeRolloverModal.value,
      "onUpdate:confirmRolloverDateModal": _cache[14] || (_cache[14] = ($event: any) => (confirmRolloverDateModal.value = $event)),
      "onUpdate:completeRolloverModal": _cache[15] || (_cache[15] = ($event: any) => (completeRolloverModal.value = $event))
    }, null, 8, ["confirmRolloverDateModal", "completeRolloverModal"])
  ], 64))
}
}

})